var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 20,
    viewBox: "0 0 11 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C8.538 2 11 4.451 11 7.476c0 1.904-1.635 4.544-4.906 7.92L5.5 16l-.594-.604C1.636 12.02 0 9.38 0 7.476 0 4.45 2.462 2 5.5 2zm0 1A4.49 4.49 0 0 0 1 7.482c0 1.52 1.416 3.855 4.285 6.884l.215.224.215-.224c2.78-2.935 4.195-5.218 4.28-6.74L10 7.483A4.492 4.492 0 0 0 5.5 3zm0 2a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 6z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

export default SvgLocation;